var APP_TYPE = 'vkappbridge';
var IOS_NOT_SUPPORT = 'iOS系统不支持此功能';
var ANDRIOD_NOT_SUPPORT = 'Andriod系统不支持此功能';
var LOW_VERSION_TIPS = '您当前APP的版本不支持此功能，请升级到最新版本再使用，谢谢！';
var LOW_VERSION_TIPS_EN = 'This version of your current app does not support this feature, please upgrade to the latest version, thank you!';

var isAndroid = /Android/i.test(window.navigator.userAgent);
var isIOS = /iPhone/i.test(window.navigator.userAgent);
var isApp = false;
isApp = !!getCookie('isFromApp') || navigator.userAgent.indexOf('vkhybrid') >= 0;

function versionCompare(currVersion, afferentVerison) {
  if (!currVersion || !afferentVerison) {
    return !currVersion ? -1 : 1;
  }

  if (currVersion === afferentVerison) {
    return 0;
  }

  var currArr = currVersion.split('.');
  var afferentArr = afferentVerison.split('.');
  var currLength = currArr.length;
  var afferentLength = afferentArr.length;
  var longestLength = currLength > afferentLength ? currLength : afferentLength;

  for (var i = 0; i < longestLength; i++) {
    if (i === currArr.length) {
      return -1;
    }

    if (i === afferentLength.length) {
      return 1;
    }

    var currValue = parseInt(currArr[i]);
    var afferentValue = parseInt(afferentArr[i]);

    if (currValue > afferentValue) {
      return 1;
    } else if (currValue < afferentValue) {
      return -1;
    }
  }

  if (longestLength === currLength) {
    return 1;
  }

  if (longestLength === afferentLength) {
    return -1;
  }
} // 获取当前 App版本号


function getCurrentAppVersion() {
  var vn = '1.0.0.0'; //默认设置版本

  try {
    var appEnv = getCookie('appEnv');

    if (appEnv) {
      appEnv = JSON.parse(appEnv);
      vn = appEnv.vn;
    }
  } catch (error) {// 版本号parse失败
  }

  return vn;
} // 当前版本号是否大于等于指定版本


function appVersionCompare(version) {
  if (isApp) {
    var current = getCurrentAppVersion();
    return versionCompare(current, version) >= 0;
  }

  return false;
} // 当前版本号是否小于指定版本


function appVersionCompareLessThan(version) {
  if (isApp) {
    var current = getCurrentAppVersion();
    return versionCompare(current, version) < 0;
  }

  return false;
}

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();

    if (c.indexOf(name) === 0) {
      return decodeURIComponent(c.substring(name.length, c.length));
    }
  }

  return '';
}

var Version = {
  isAndroid: isAndroid,
  isIOS: isIOS,
  isApp: isApp,
  vn: getCurrentAppVersion(),
  appVersionCompare: appVersionCompare,
  appVersionCompareLessThan: appVersionCompareLessThan
};

function getIframe() {
  var appBridgeIframe = document.createElement('iframe');
  appBridgeIframe.setAttribute('id', 'appBridgeIframe');
  appBridgeIframe.style.visibility = 'invisible';
  appBridgeIframe.style.display = 'none';
  appBridgeIframe.style.height = '0';
  appBridgeIframe.style.width = '0';
  document.body.appendChild(appBridgeIframe);
  setTimeout(function () {
    document.body.removeChild(appBridgeIframe);
  }, 5000);
  return appBridgeIframe;
}

var callbackList = [];

var appExe = function appExe(command) {
  // 非APP环境，发自定义的scheme会出问题
  if (Version.isApp) {
    return new Promise(function (resolve, reject) {
      var hash = command.split('#')[1];
      var iframe = getIframe();

      if (hash) {
        var callbackid = hash.replace('#', '');
        callbackList.push({
          id: callbackid,
          resolve: resolve,
          reject: reject
        });
      }

      iframe.contentWindow.location.replace(command);
    });
  }
};

var setPromise = function setPromise(response) {
  for (var index = 0; index < callbackList.length; index++) {
    if (callbackList[index].id === response.responseId) {
      response.responseData.code !== 200 ? callbackList[index].reject(response.responseData) : callbackList[index].resolve(response.responseData);
      callbackList.splice(index, 1);
      break;
    }
  }
};

var toastShow = function toastShow() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.duration) {
    params.duration = 2000; //默认2秒
  }

  if (!params.text) {
    throw 'parameter text is expected';
  }

  appExe("".concat(APP_TYPE, "://toast/show?text=").concat(encodeURIComponent(params.text), "&duration=").concat(encodeURIComponent(params.duration)));
};

var appAvailable = function appAvailable() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://app/available#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var appEnv = function appEnv() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://app/env#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var appOpenUrl = function appOpenUrl(params) {
  if (Version.appVersionCompareLessThan('2.0.1')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.url) {
    throw 'parameter url is expected';
  }

  var uri = "".concat(APP_TYPE, "://app/openURL?url=").concat(encodeURIComponent(params.url));

  if (params.target) {
    uri = uri + '&target=' + encodeURIComponent(params.target);
  }

  appExe(uri);
};

var historyBack = function historyBack() {
  appExe("".concat(APP_TYPE, "://history/back"));
};

var loadingStart = function loadingStart() {
  appExe("".concat(APP_TYPE, "://loading/start"));
};

var loadingStop = function loadingStop() {
  appExe("".concat(APP_TYPE, "://loading/stop"));
};

var index = {
  appAvailable: appAvailable,
  appEnv: appEnv,
  appOpenUrl: appOpenUrl,
  historyBack: historyBack,
  loadingStart: loadingStart,
  loadingStop: loadingStop,
  toastShow: toastShow
};

var applyPermission = function applyPermission(params) {
  if (Version.isIOS && (params.permissions === 'phone' || params.permissions === 'contacts')) {
    toastShow({
      text: IOS_NOT_SUPPORT
    });
    return;
  }

  if (Version.isAndroid && Version.appVersionCompareLessThan('1.10.1')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.permissions) {
    throw 'parameter permissions is expected';
  }

  var uri = "".concat(APP_TYPE, "://apply/permission?permissions=").concat(encodeURIComponent(params.permissions));

  if (params.checkOnly) {
    uri = uri + '&checkOnly=' + encodeURIComponent(params.checkOnly);
  } else {
    if (Version.isIOS && Version.vn === '2.19.0') {
      // 兼容app上的bug
      uri = uri + '&checkOnly=true';
    }
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      if (Version.isIOS && Version.vn === '2.19.0' && data.data && data.data.result === false) {
        alert('需要开启VIPKID英语的APP相册和相机权限“设置>VIPKID英语>照片-读取与写入>相机-开启”，开启权限后即可使用~');
      }

      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var applyScheme = function applyScheme(params) {
  if (Version.isAndroid) {
    toastShow({
      text: ANDRIOD_NOT_SUPPORT
    });
    return;
  }

  if (Version.appVersionCompareLessThan('2.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.scheme) {
    throw 'parameter scheme is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://apply/scheme?scheme=").concat(encodeURIComponent(params.scheme), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var applyOpenScheme = function applyOpenScheme(params) {
  if (Version.isAndroid) {
    toastShow({
      text: ANDRIOD_NOT_SUPPORT
    });
    return;
  }

  if (Version.appVersionCompareLessThan('2.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (params.installSchemeURL === undefined) {
    throw 'parameter installSchemeURL is expected';
  }

  var uri = "".concat(APP_TYPE, "://apply/openScheme?installSchemeURL=").concat(encodeURIComponent(params.installSchemeURL));

  if (params.uninstallSchemeURL) {
    uri = uri + '&uninstallSchemeURL=' + encodeURIComponent(params.uninstallSchemeURL);
  }

  appExe(uri);
};

var status_sync = function status_sync() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/status_sync#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var init = function init(params) {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/init?businessCode=").concat(encodeURIComponent(params.businessCode), "&songsList=").concat(encodeURIComponent(JSON.stringify(params.songsList)), "&targetUrl=").concat(encodeURIComponent(params.targetUrl), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var play = function play() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.index || params.index === 0) {
    appExe("".concat(APP_TYPE, "://audio/play?index=").concat(params.index));
  } else {
    appExe("".concat(APP_TYPE, "://audio/play"));
  }
};

var pause = function pause() {
  appExe("".concat(APP_TYPE, "://audio/pause"));
};

var pre = function pre() {
  appExe("".concat(APP_TYPE, "://audio/pre"));
};

var next = function next() {
  appExe("".concat(APP_TYPE, "://audio/next"));
};

var slide = function slide(params) {
  appExe("".concat(APP_TYPE, "://audio/slide?progress=").concat(params.progress));
};

var setCycleMode = function setCycleMode(params) {
  appExe("".concat(APP_TYPE, "://audio/cycle_mode?mode=").concat(params.mode));
};

var close = function close() {
  appExe("".concat(APP_TYPE, "://audio/close"));
};

var get_progress = function get_progress() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/get_progress#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var add = function add(params) {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/add?index=").concat(encodeURIComponent(params.index), "&songsList=").concat(encodeURIComponent(JSON.stringify(params.songsList)), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var remove = function remove(params) {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/remove?ids=").concat(encodeURIComponent(JSON.stringify(params.ids)), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var time_off = function time_off(params) {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio/time_off?time=").concat(encodeURIComponent(params.time), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var audio = {
  status_sync: status_sync,
  init: init,
  play: play,
  pause: pause,
  pre: pre,
  next: next,
  slide: slide,
  setCycleMode: setCycleMode,
  close: close,
  get_progress: get_progress,
  add: add,
  remove: remove,
  time_off: time_off
};

var audioRecordStart = function audioRecordStart(params) {
  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  var uri = "".concat(APP_TYPE, "://audioRecord/start");
  var containParam = false;

  if (params.needAudio) {
    uri += "?needAudio=".concat(encodeURIComponent(params.needAudio));
    containParam = true;
  }

  if (params.maxDuration) {
    uri += (containParam ? '&' : '?') + "maxDuration=".concat(encodeURIComponent(params.maxDuration));
    containParam = true;
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var audioRecordStop = function audioRecordStop() {
  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audioRecord/stop")).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var calendarSyncCourse = function calendarSyncCourse(params) {
  if (Version.appVersionCompareLessThan('2.9.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.studentId) {
    throw 'parameter studentId is expected';
  }

  if (!params.calendarData) {
    throw 'parameter calendarData is expected';
  }

  if (!(params.calendarData instanceof Array)) {
    throw 'parameter calendarData should be Array';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://calendar/syncCourse?studentId=").concat(params.studentId, "&calendarData=").concat(JSON.stringify(params.calendarData), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var calendarInsertAlarm = function calendarInsertAlarm(params) {
  if (params.calendarData === undefined) {
    throw 'parameter calendarData is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://calendar/insertAlarm?calendarData=").concat(encodeURIComponent(JSON.stringify(params.calendarData)), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var getNetType = function getNetType() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://net/gettype?#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var paypp = function paypp(params) {
  if (!Version.isAndroid) {
    toastShow({
      text: IOS_NOT_SUPPORT
    });
    return;
  }

  if (!params.data) {
    throw 'parameter data is expected';
  }

  if (!params.channel) {
    throw 'parameter channel is expected';
  }

  if (params.channel === 'wechat' && Version.appVersionCompareLessThan('2.0.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://pay/pingpp?channel=").concat(encodeURIComponent(params.channel), "&data=").concat(encodeURIComponent(params.data), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var payDirect = function payDirect(params) {
  if (!Version.isAndroid) {
    toastShow({
      text: IOS_NOT_SUPPORT
    });
    return;
  }

  if (Version.appVersionCompareLessThan('2.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.channel) {
    throw 'parameter channel is expected';
  }

  if (!params.data) {
    throw 'parameter data is expected';
  }

  if ((params.channel === 'webank' || params.channel === 'baidu') && Version.appVersionCompareLessThan('2.6.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (params.channel === 'zl' && Version.appVersionCompareLessThan('2.5.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://pay/direct?channel=").concat(encodeURIComponent(params.channel), "&data=").concat(encodeURIComponent(params.data), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var payIntercept = function payIntercept(params) {
  if (!Version.isAndroid) {
    toastShow({
      text: IOS_NOT_SUPPORT
    });
    return;
  }

  if (Version.appVersionCompareLessThan('1.14.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.channel) {
    throw 'parameter channel is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://pay/intercept?channel=").concat(encodeURIComponent(params.channel), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var phoneCall = function phoneCall(params) {
  if (Version.isAndroid && Version.appVersionCompareLessThan('1.9.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.phone_number) {
    throw 'parameter phone_number is expected';
  }

  appExe("".concat(APP_TYPE, "://phone/call?phone_number=").concat(encodeURIComponent(params.phone_number)));
};

var shareInfo = function shareInfo(params) {
  if (!params.title) {
    throw 'parameter title is expected';
  }

  if (!params.description) {
    throw 'parameter description is expected';
  }

  if (!params.thumbnail) {
    throw 'parameter thumbnail is expected';
  }

  if (!params.link) {
    throw 'parameter link is expected';
  }

  var uri = "".concat(APP_TYPE, "://share/info?title=").concat(encodeURIComponent(params.title), "&description=").concat(encodeURIComponent(params.description), "&thumbnail=").concat(encodeURIComponent(params.thumbnail), "&link=").concat(encodeURIComponent(params.link));

  if (params.type) {
    uri = uri + '&type=' + encodeURIComponent(params.type);
  }

  if (params.channel) {
    uri = uri + '&channel=' + encodeURIComponent(params.channel);
  }

  if (params.track) {
    uri = uri + '&track=' + encodeURIComponent(params.track);
  }

  if (params.trackContent) {
    uri = uri + '&trackContent=' + encodeURIComponent(params.trackContent);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var shareLink = function shareLink(params) {
  if (!params.title) {
    throw 'parameter title is expected';
  }

  if (!params.description) {
    throw 'parameter description is expected';
  }

  if (!params.thumbnail) {
    throw 'parameter thumbnail is expected';
  }

  if (!params.link) {
    throw 'parameter link is expected';
  }

  var uri = "".concat(APP_TYPE, "://share/info?title=").concat(encodeURIComponent(params.title), "&description=").concat(encodeURIComponent(params.description), "&thumbnail=").concat(encodeURIComponent(params.thumbnail), "&link=").concat(encodeURIComponent(params.link), "&type=");

  if (params.channel) {
    uri = uri + '&channel=' + encodeURIComponent(params.channel);
  }

  if (params.track) {
    uri = uri + '&track=' + encodeURIComponent(params.track);
  }

  if (params.trackContent) {
    uri = uri + '&trackContent=' + encodeURIComponent(params.trackContent);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var shareWXApplet = function shareWXApplet(params) {
  if (!params.title) {
    throw 'parameter title is expected';
  }

  if (!params.desc) {
    throw 'parameter desc is expected';
  }

  if (!params.imgUrl) {
    throw 'parameter imgUrl is expected';
  }

  if (!params.link) {
    throw 'parameter link is expected';
  }

  if (!params.miniId) {
    throw 'parameter miniId is expected';
  }

  if (!params.miniPath) {
    throw 'parameter miniPath is expected';
  }

  if (!params.miniHdImage) {
    throw 'parameter miniHdImage is expected';
  }

  if (Version.appVersionCompareLessThan('2.5.1')) {
    return new Promise(function (resolve, reject) {
      //2.5.1版本之前会退回到Link型分享
      shareLink({
        title: params.title,
        description: params.desc,
        thumbnail: params.imgUrl,
        link: params.link,
        channel: params.channel
      }).then(function (res) {
        resolve(res);
      })["catch"](function (err) {
        reject(err);
      });
    });
  } // iOS 2.5.1与2.6.0版本 小程序无法拿到回调结果 统一使用H5分享


  if (Version.isIOS) {
    if (Version.vn === '2.5.1' || Version.vn === '2.6.0') {
      return new Promise(function (resolve, reject) {
        shareLink({
          title: params.title,
          description: params.desc,
          thumbnail: params.imgUrl,
          link: params.link,
          channel: params.channel
        }).then(function (res) {
          resolve(res);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://share/info?title=").concat(encodeURIComponent(params.title), "&desc=").concat(encodeURIComponent(params.desc), "&imgUrl=").concat(encodeURIComponent(params.imgUrl), "&link=").concat(encodeURIComponent(params.link), "&channel=").concat(encodeURIComponent(params.channel), "&type=4&miniId=").concat(encodeURIComponent(params.miniId), "&miniPath=").concat(encodeURIComponent(params.miniPath), "&miniHdImage=").concat(encodeURIComponent(params.miniHdImage), "&miniShareTicket=").concat(encodeURIComponent(params.miniShareTicket), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var shareImg = function shareImg(params) {
  var uri = '';

  if (params.imgUrl === undefined) {
    if (params.imgData === undefined) {
      throw 'parameter imgUrl or imgData is expected';
    } else {
      uri = "vipkid://share?imgData=".concat(encodeURIComponent(params.imgData), "&type=1");
    }
  } else {
    uri = "vipkid://share?imgUrl=".concat(encodeURIComponent(params.imgUrl), "&type=1");
  }

  if (params.link) {
    uri = "".concat(uri, "&link=").concat(encodeURIComponent(params.link));
  }

  if (params.channel) {
    uri = "".concat(uri, "&channel=").concat(encodeURIComponent(params.channel));
  }

  if (params.track) {
    uri = "".concat(uri, "&track=").concat(encodeURIComponent(params.track));
  }

  if (params.trackContent !== undefined) {
    uri = "".concat(uri, "&trackContent=").concat(encodeURIComponent(params.trackContent));
  }

  uri = "".concat(uri, "#function_").concat(new Date().getTime());
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var openMiniProgram = function openMiniProgram(params) {
  if (!params.username) {
    throw 'parameter username is expected';
  }

  var uri = "".concat(APP_TYPE, "://share/openminiprogram?username=").concat(encodeURIComponent(params.username));

  if (params.path) {
    uri = "".concat(uri, "&path=").concat(encodeURIComponent(params.path));
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var tabbarVisibility = function tabbarVisibility(params) {
  if (!params.isVisible) {
    throw 'parameter isVisible is expected';
  }

  if (!params["function"]) {
    throw 'parameter function is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://app.tabbar/visibility?isVisible=").concat(encodeURIComponent(params.isVisible), "&function=").concat(encodeURIComponent(params["function"]), "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var tabHideTips = function tabHideTips(params) {
  if (!params.tabindex) {
    throw 'parameter tabindex is expected';
  }

  appExe("".concat(APP_TYPE, "://tab/hidetips?tabindex=").concat(encodeURIComponent(params.tabindex)));
};

var trackClick = function trackClick(params) {
  if (Version.appVersionCompareLessThan('2.5.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (Version.isIOS && Version.appVersionCompareLessThan('2.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.clickId) {
    throw 'parameter clickId is expected';
  }

  var uri = "".concat(APP_TYPE, "://track/click?clickId=").concat(encodeURIComponent(params.clickId));

  if (params.params) {
    uri = uri + '&params=' + encodeURIComponent(JSON.stringify(params.params));
  }

  appExe(uri);
};

var trackTrigger = function trackTrigger(params) {
  if (Version.appVersionCompareLessThan('2.5.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (Version.isIOS && Version.appVersionCompareLessThan('2.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.triggerId) {
    throw 'parameter triggerId is expected';
  }

  var uri = "".concat(APP_TYPE, "://track/trigger?triggerId=").concat(encodeURIComponent(params.triggerId));

  if (params.params) {
    uri = uri + '&params=' + encodeURIComponent(JSON.stringify(params.params));
  }

  appExe(uri);
};

var trackPageview = function trackPageview(params) {
  if (!params.pageName) {
    throw 'parameter pageName is expected';
  }

  if (!params.event) {
    throw 'parameter event is expected';
  }

  var uri = "".concat(APP_TYPE, "://track/pageview?pageName=").concat(encodeURIComponent(params.pageName), "&event=").concat(encodeURIComponent(params.event));

  if (params.params) {
    if (Version.isIOS && Version.appVersionCompareLessThan('2.31.0')) {
      appExe(uri);
    } else {
      uri = uri + '&params=' + encodeURIComponent(JSON.stringify(params.params));
      appExe(uri);
    }
  } else {
    appExe(uri);
  }
};

var trackRecordLaunchTime = function trackRecordLaunchTime(params) {
  if (Version.appVersionCompareLessThan('2.21.0')) {
    return;
  }

  if (!params.url) {
    throw 'parameter url is expected';
  }

  var uri = "".concat(APP_TYPE, "://track/recordLaunchTime?url=").concat(encodeURIComponent(params.url));

  if (params.params) {
    uri = uri + '&params=' + encodeURIComponent(JSON.stringify(params.params));
  }

  appExe(uri);
};

var upgradeShowTips = function upgradeShowTips(params) {
  if (!params.upgradeInfo) {
    throw 'parameter upgradeInfo is expected';
  }

  appExe("".concat(APP_TYPE, "://upgrade/showTips?upgradeInfo=").concat(encodeURIComponent(params.upgradeInfo)));
};

var userGetRequestInfo = function userGetRequestInfo() {
  appExe("".concat(APP_TYPE, "://user/getRequestInfo"));
};

var userLogin = function userLogin() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.phone === undefined) {
    throw 'parameter phone is expected';
  }

  if (params.loginType !== 'sms' || params.loginType !== 'pwd') {
    params.loginType = 'sms';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://user/login?phone=").concat(encodeURIComponent(params.phone), "&loginType=").concat(encodeURIComponent(params.loginType), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var userLogout = function userLogout() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.phone === undefined) {
    throw 'parameter phone is expected';
  }

  if (params.loginType !== 'sms' || params.loginType !== 'pwd') {
    params.loginType = 'sms';
  }

  appExe("".concat(APP_TYPE, "://user/logout?phone=").concat(encodeURIComponent(params.phone), "&loginType=").concat(encodeURIComponent(params.loginType)));
};

var userSyncAddressBook = function userSyncAddressBook() {
  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://user/syncAddressBook#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var userCallSMS = function userCallSMS() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uri = "".concat(APP_TYPE, "://user/callSMS");

  if (params.recipients) {
    uri = uri + '?recipients=' + encodeURIComponent(JSON.stringify(params.recipients));

    if (params.message) {
      uri = uri + '&message=' + encodeURIComponent(params.message);
    }
  } else {
    if (params.message) {
      uri = uri + '?message=' + encodeURIComponent(params.message);
    }
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var userWriteContacts = function userWriteContacts() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uri = "".concat(APP_TYPE, "://user/writeContacts");

  if (params.contacts) {
    uri = uri + '?contacts=' + encodeURIComponent(JSON.stringify(params.contacts));
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var videoPlay = function videoPlay() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.isAndroid && Version.appVersionCompareLessThan('1.9.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.url) {
    throw 'parameter url is expected';
  }

  if (!params.title) {
    throw 'parameter title is expected';
  }

  if (!params.start_time) {
    params.start_time = 0;
  }

  var uri = "".concat(APP_TYPE, "://video/play?video_url=").concat(encodeURIComponent(params.url), "&title=").concat(encodeURIComponent(params.title), "&start_time=").concat(encodeURIComponent(params.start_time));

  if (params.can_cache && Version.appVersionCompare('2.18.0')) {
    uri = uri + '&is_can_download=' + encodeURIComponent(params.can_cache);
  }

  if (params.cover_url && Version.appVersionCompare('2.18.0')) {
    uri = uri + '&cover_url=' + encodeURIComponent(params.cover_url);
  }

  if (params.videoId && Version.appVersionCompare('2.26.0')) {
    uri = uri + '&videoId=' + encodeURIComponent(params.videoId);
  }

  if (params.videoType && Version.appVersionCompare('2.26.0')) {
    uri = uri + '&videoType=' + encodeURIComponent(params.videoType);
  }

  if (params.isTimeUpdate !== undefined && Version.appVersionCompare('2.26.0')) {
    uri = uri + '&isTimeUpdate=' + encodeURIComponent(params.isTimeUpdate);
  }

  appExe(uri);
};

var webLoadReady = function webLoadReady() {
  appExe("".concat(APP_TYPE, "://web/is_load_ready"));
};

var clipboardCopy = function clipboardCopy() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('2.10.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://clipboard/stringCopy?content=").concat(params.content, "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var fileUpload = function fileUpload(params) {
  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.path) {
    throw 'parameter path is expected';
  }

  if (!params.businessType) {
    throw 'parameter businessType is expected';
  }

  var uri = "".concat(APP_TYPE, "://file/upload?path=").concat(encodeURIComponent(params.path), "&businessType=").concat(encodeURIComponent(params.businessType));

  if (params.deleteFile) {
    uri += "&deleteFile=".concat(encodeURIComponent(params.deleteFile));
  }

  uri += '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var scanOpenQR = function scanOpenQR() {

  if (Version.isAndroid && Version.appVersionCompareLessThan('2.12.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (Version.isIOS && Version.appVersionCompareLessThan('2.12.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://scan/open_qr#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var innerPurchase = function innerPurchase(params) {
  if (Version.isAndroid) {
    toastShow({
      text: ANDRIOD_NOT_SUPPORT
    });
    return;
  }

  if (Version.appVersionCompareLessThan('2.12.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.productId) {
    throw 'parameter productId is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://innerPurchase/buyProduct?productId=").concat(params.productId, "#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var imEntry = function imEntry() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('2.14.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.status) {
    throw 'parameter status is expected';
  }

  var uri = "".concat(APP_TYPE, "://imEntry/display?status=").concat(encodeURIComponent(params.status));

  if (params.eventId) {
    uri = uri + '&eventId=' + encodeURIComponent(params.eventId);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var handleWithBabyId = function handleWithBabyId() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('2.15.0')) {
    return new Promise(function (resolve, reject) {
      reject({
        code: 1000,
        errorText: 'CURRENT_APP_NOT_SUPPORT',
        versionSupport: '2.15.0'
      });
    });
  }

  if (!params.studentId) {
    throw 'parameter studentId is expected';
  }

  var uri = "".concat(APP_TYPE, "://babySwitch/handleWithBabyId?studentId=").concat(encodeURIComponent(params.studentId));

  if (params.landingPath) {
    uri = uri + '&landingPath=' + encodeURIComponent(params.landingPath);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var galleryShow = function galleryShow() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('2.16.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  if (!params.data) {
    throw 'parameter data is expected';
  }

  var uri = "".concat(APP_TYPE, "://gallery/show?data=").concat(JSON.stringify(params.data));

  if (params.currentPage) {
    uri = uri + '&currentPage=' + JSON.stringify(params.currentPage);
  }

  appExe(uri);
};

var screenShotQuery = function screenShotQuery() {

  if (Version.appVersionCompareLessThan('2.18.0')) {
    toastShow({
      text: LOW_VERSION_TIPS
    });
    return;
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://screenShot/query#function_").concat(new Date().getTime())).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var statusBarColor = function statusBarColor() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.backgroundColor) {
    throw 'parameter backgroundColor is expected';
  }

  if (!params.textStyle) {
    throw 'parameter textStyle is expected';
  }

  appExe("".concat(APP_TYPE, "://statusBar/color?backgroundColor=").concat(encodeURIComponent(params.backgroundColor), "&textStyle=").concat(encodeURIComponent(params.textStyle)));
};

var statusBarMode = function statusBarMode() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.isFullScreen) {
    throw 'parameter isFullScreen is expected';
  }

  appExe("".concat(APP_TYPE, "://statusBar/mode?isFullScreen=").concat(encodeURIComponent(params.isFullScreen)));
};

var showtimeVideo = function showtimeVideo() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.activityid) {
    throw 'parameter activityid is expected';
  }

  var uri = "".concat(APP_TYPE, "://showtime/video?activityid=").concat(encodeURIComponent(params.activityid));

  if (params.maxduration) {
    uri = uri + '&maxduration=' + encodeURIComponent(params.maxduration);
  }

  if (params.needcover) {
    uri = uri + '&needcover=' + encodeURIComponent(params.needcover);
  } else {
    uri = uri + '&needcover=1';
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var showtimeUSTVideo = function showtimeUSTVideo() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.activityid) {
    throw 'parameter activityid is expected';
  }

  var uri = "".concat(APP_TYPE, "://showtime/ustvideo?activityid=").concat(encodeURIComponent(params.activityid));

  if (params.needcover) {
    uri = uri + '&needcover=' + encodeURIComponent(params.needcover);
  } else {
    uri = uri + '&needcover=1';
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var selectPhoto = function selectPhoto() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uri = "".concat(APP_TYPE, "://photo/selectPhoto");

  if (params.count) {
    uri = uri + '?count=' + encodeURIComponent(params.count);
  } else {
    uri = uri + '?count=1';
  }

  if (params.quality) {
    uri = uri + '&quality=' + encodeURIComponent(params.quality);
  }

  if (params.channel) {
    uri = uri + '&channel=' + encodeURIComponent(params.channel);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var compressPhoto = function compressPhoto() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!params.dataList) {
    throw 'parameter dataList is expected';
  }

  var date = new Date().getTime();

  if (window.VKAppBridge) {
    window.VKAppBridge['fetchMessageQueue'] = function () {
      var row = ["vkappbridge://photo/compress?data=".concat(encodeURIComponent(JSON.stringify(params.dataList)), "#function_").concat(date)];
      return JSON.stringify(row);
    };
  }

  var uri = "".concat(APP_TYPE, "://__bridge_message__");
  uri = uri + '#function_' + date;
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var savePhoto = function savePhoto() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uri = "".concat(APP_TYPE, "://photo/save?url=").concat(encodeURIComponent(JSON.stringify(params.url)));

  if (params.type !== undefined) {
    uri = uri + '&type=' + params.type;
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (data) {
      resolve(data);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var multipathAction = function multipathAction() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.isAndroid) {
    toastShow({
      text: ANDRIOD_NOT_SUPPORT
    });
    return;
  }

  var uri = "".concat(APP_TYPE, "://multipath/action");

  if (params["switch"]) {
    uri = uri + '?switch=' + encodeURIComponent(params["switch"]);
  }

  uri = uri + '#function_' + new Date().getTime();
  return new Promise(function (resolve, reject) {
    appExe(uri).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var index$1 = {
  applyPermission: applyPermission,
  applyScheme: applyScheme,
  applyOpenScheme: applyOpenScheme,
  audio: audio,
  audioRecordStart: audioRecordStart,
  audioRecordStop: audioRecordStop,
  calendarSyncCourse: calendarSyncCourse,
  calendarInsertAlarm: calendarInsertAlarm,
  getNetType: getNetType,
  paypp: paypp,
  payDirect: payDirect,
  payIntercept: payIntercept,
  phoneCall: phoneCall,
  shareInfo: shareInfo,
  shareLink: shareLink,
  shareWXApplet: shareWXApplet,
  shareImg: shareImg,
  openMiniProgram: openMiniProgram,
  tabbarVisibility: tabbarVisibility,
  tabHideTips: tabHideTips,
  trackClick: trackClick,
  trackTrigger: trackTrigger,
  trackPageview: trackPageview,
  trackRecordLaunchTime: trackRecordLaunchTime,
  upgradeShowTips: upgradeShowTips,
  userGetRequestInfo: userGetRequestInfo,
  userLogin: userLogin,
  userLogout: userLogout,
  userSyncAddressBook: userSyncAddressBook,
  userCallSMS: userCallSMS,
  userWriteContacts: userWriteContacts,
  videoPlay: videoPlay,
  webLoadReady: webLoadReady,
  clipboardCopy: clipboardCopy,
  fileUpload: fileUpload,
  scanOpenQR: scanOpenQR,
  innerPurchase: innerPurchase,
  imEntry: imEntry,
  handleWithBabyId: handleWithBabyId,
  galleryShow: galleryShow,
  screenShotQuery: screenShotQuery,
  statusBarColor: statusBarColor,
  statusBarMode: statusBarMode,
  showtimeVideo: showtimeVideo,
  showtimeUSTVideo: showtimeUSTVideo,
  selectPhoto: selectPhoto,
  compressPhoto: compressPhoto,
  savePhoto: savePhoto,
  multipathAction: multipathAction
};

var startRecord = function startRecord(params) {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  if (!params.maxDuration) {
    throw 'parameter maxDuration is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_record/startRecord?maxDuration=").concat(encodeURIComponent(params.maxDuration), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var stopRecord = function stopRecord() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_record/stopRecord#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var cancelRecord = function cancelRecord() {
  appExe("".concat(APP_TYPE, "://audio_record/cancelRecord#function_").concat(new Date().getTime()));
};

var startPlay = function startPlay() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_media/startPlay#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var stopPlay = function stopPlay() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_media/stopPlay#function_").concat(new Date().getTime()));
  });
};

var pausePlay = function pausePlay() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_media/pausePlay#function_").concat(new Date().getTime()));
  });
};

var resumePlay = function resumePlay() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_media/resumePlay#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var startUpload = function startUpload() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_upload/startUpload#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var cancelUpload = function cancelUpload() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_upload/cancelUpload#function_").concat(new Date().getTime()));
  });
};

var pauseUpload = function pauseUpload() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_upload/pauseUpload#function_").concat(new Date().getTime()));
  });
};

var resumeUpload = function resumeUpload() {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://audio_upload/resumeUpload#function_").concat(new Date().getTime()));
  });
};

var checkCameraPermission = function checkCameraPermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/checkCameraPermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var requestCameraPermission = function requestCameraPermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/requestCameraPermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var checkMicrophonePermission = function checkMicrophonePermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/checkMicrophonePermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var requestMicrophonePermission = function requestMicrophonePermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/requestMicrophonePermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var checkExternalStoragePermission = function checkExternalStoragePermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/checkExternalStoragePermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var requestExternalStoragePermission = function requestExternalStoragePermission() {
  if (Version.appVersionCompareLessThan('3.3.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://device/requestExternalStoragePermission#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var recruitCompleteQuiz = function recruitCompleteQuiz() {
  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  appExe("".concat(APP_TYPE, "://recruit/completeQuestion"));
};

var recruitBackgroundSign = function recruitBackgroundSign() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.checkbox === undefined) {
    throw 'parameter checkbox is expected';
  }

  appExe("".concat(APP_TYPE, "://recruit/backgroundSignature?checkbox=").concat(params.checkbox));
};

var pageNavigation = function pageNavigation() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  if (params.show === undefined) {
    throw 'parameter show is expected';
  }

  appExe("".concat(APP_TYPE, "://page/navigation?show=").concat(params.show));
};

var pageClose = function pageClose() {
  if (Version.appVersionCompareLessThan('3.4.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  appExe("".concat(APP_TYPE, "://page/close"));
};

var pageLogout = function pageLogout() {
  if (Version.appVersionCompareLessThan('3.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  appExe("".concat(APP_TYPE, "://page/logout"));
};

var pageLeftNavBtn = function pageLeftNavBtn() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.type === undefined) {
    throw 'parameter type is expected';
  }

  if (params.clickable === undefined) {
    throw 'parameter clickable is expected';
  }

  appExe("".concat(APP_TYPE, "://page/leftNavBtn?type=").concat(encodeURIComponent(params.type), "&clickable=").concat(encodeURIComponent(params.clickable), "&content=").concat(encodeURIComponent(params.content)));
};

var pageRightNavBtn = function pageRightNavBtn() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.type === undefined) {
    throw 'parameter type is expected';
  }

  if (params.clickable === undefined) {
    throw 'parameter clickable is expected';
  }

  appExe("".concat(APP_TYPE, "://page/rightNavBtn?type=").concat(encodeURIComponent(params.type), "&clickable=").concat(encodeURIComponent(params.clickable), "&content=").concat(encodeURIComponent(params.content)));
};

var pageTitle = function pageTitle() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (params.title === undefined) {
    throw 'parameter title is expected';
  }

  appExe("".concat(APP_TYPE, "://page/title?title=").concat(encodeURIComponent(params.title)));
};

var shareInfo$1 = function shareInfo(params) {
  if (Version.appVersionCompareLessThan('2.2.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  if (!params.link) {
    throw 'parameter link is expected';
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://share/info?link=").concat(encodeURIComponent(params.link), "&title=").concat(encodeURIComponent(params.title), "&desc=").concat(encodeURIComponent(params.desc), "&imgUrl=").concat(encodeURIComponent(params.imgUrl), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var feedSend = function feedSend(params) {
  if (Version.appVersionCompareLessThan('2.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  return new Promise(function (resolve, reject) {
    appExe("".concat(APP_TYPE, "://feed/send?duration=").concat(encodeURIComponent(params.duration), "&framerate=").concat(encodeURIComponent(params.framerate), "&coderate=").concat(encodeURIComponent(params.coderate), "&forbidconvert=").concat(encodeURIComponent(params.forbidconvert), "&maxsize=").concat(encodeURIComponent(params.maxsize), "&exportLevel=").concat(encodeURIComponent(params.exportLevel), "&title=").concat(encodeURIComponent(params.title), "&tag=").concat(encodeURIComponent(params.tag), "&activityId=").concat(encodeURIComponent(params.activityId), "#function_").concat(new Date().getTime())).then(function (res) {
      resolve(res);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

var firebaseMarket = function firebaseMarket() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Version.appVersionCompareLessThan('3.7.0')) {
    toastShow({
      text: LOW_VERSION_TIPS_EN
    });
  }

  if (!params.event) {
    throw 'parameter event is expected';
  }

  var uri = "".concat(APP_TYPE, "://common/firebaseMarket?event=").concat(encodeURIComponent(params.event));

  if (params.map) {
    uri = uri + '&map=' + encodeURIComponent(params.map);
  }

  appExe(uri);
};

var index$2 = {
  startRecord: startRecord,
  stopRecord: stopRecord,
  cancelRecord: cancelRecord,
  startPlay: startPlay,
  stopPlay: stopPlay,
  pausePlay: pausePlay,
  resumePlay: resumePlay,
  startUpload: startUpload,
  cancelUpload: cancelUpload,
  pauseUpload: pauseUpload,
  resumeUpload: resumeUpload,
  checkCameraPermission: checkCameraPermission,
  requestCameraPermission: requestCameraPermission,
  checkMicrophonePermission: checkMicrophonePermission,
  requestMicrophonePermission: requestMicrophonePermission,
  checkExternalStoragePermission: checkExternalStoragePermission,
  requestExternalStoragePermission: requestExternalStoragePermission,
  recruitCompleteQuiz: recruitCompleteQuiz,
  recruitBackgroundSign: recruitBackgroundSign,
  pageClose: pageClose,
  pageLogout: pageLogout,
  pageNavigation: pageNavigation,
  pageLeftNavBtn: pageLeftNavBtn,
  pageRightNavBtn: pageRightNavBtn,
  pageTitle: pageTitle,
  shareInfo: shareInfo$1,
  feedSend: feedSend,
  firebaseMarket: firebaseMarket
};

//通用
var BridgeEventBus = {
  on: function on(eventName, fn) {
    if (!this._eventsCallbacks) {
      this._eventsCallbacks = {};
    }

    if (!this._eventsCallbacks[eventName]) {
      this._eventsCallbacks[eventName] = [];
    }

    this._eventsCallbacks[eventName].push(fn);
  },
  remove: function remove(eventName, fn) {
    if (!this._eventsCallbacks) {
      return;
    }

    if (!this._eventsCallbacks[eventName]) {
      return;
    }

    var fnIndex = this._eventsCallbacks[eventName].indexOf(fn);

    while (fnIndex >= 0) {
      this._eventsCallbacks[eventName].splice(fnIndex, 1);

      fnIndex = this._eventsCallbacks[eventName].indexOf(fn);
    }
  },
  _fire: function _fire(eventName, data) {
    var eventsCallbacks = this._eventsCallbacks[eventName];

    if (eventsCallbacks) {
      for (var i = 0; i < eventsCallbacks.length; i++) {
        eventsCallbacks[i](data);
      }
    }
  }
};

if (!window.VKAppBridge) {
  window.VKAppBridge = {};
}

window.VKAppBridge.receiveFromNative = function (res) {
  //监听native向页面发送的消息
  try {
    var response = JSON.parse(res);

    if (response.callbackId && response.method === 'web/is_load_ready') {
      appExe("vkappbridge://__bridge_callback__#".concat(response.callbackId));
    }

    if (response.module && response.method) {
      BridgeEventBus._fire(response.module + '_' + response.method, response.data); // 例： response = {callbackId: "", module: "", method: "", data: {}}

    } else {
      setPromise(response); // 例： response = {responseId:"", responseData: {code:200, message:"", data: {}}}
    }
  } catch (err) {// 回传结果pares失败
  }
}; // js一加载就调用ready


setTimeout(function () {
  appExe('vkappbridge://__bridge_ready__');
}, 300);

export { BridgeEventBus, index as CommonBridge, index$1 as ParentBridge, index$2 as TeacherBridge };
